import React, {Component} from 'react';
import {connect} from "react-redux";
import {Card, Row, Tabs} from 'antd';
import {StyledContent} from '../../styles/mixins';
import DefaultPage from './defaultPage'
import AccountPage from './accountPage'
import CashManagementPage from "./cashManagementPage";
const TabPane = Tabs.TabPane

class Settings extends Component {
  
  state = {
    activeTab: this.props.match.params.tab || 'defaults'
  }
  
  onTabChange = (activeTab) => {
      this.setState({
        activeTab,
      });
      this.props.history.push(`/settings/${activeTab}`);
  }
  
  render() {
    const { permissions } = this.props
    const { portfolioTools } = permissions
    return (
      <StyledContent>
        <Card title="Settings" bordered={false}>
          {
            portfolioTools ?
              <Tabs type="card">
                <TabPane tab="Trades" key="defaults">
                  <Tabs activeKey={this.state.activeTab} onChange={this.onTabChange}>
                    <TabPane tab="Defaults" key="defaults">
                      <DefaultPage/>
                    </TabPane>
                    <TabPane tab="Accounts" key="accounts">
                      <AccountPage/>
                    </TabPane>
                    <TabPane tab="Cash Management" key="cash">
                      <CashManagementPage/>
                    </TabPane>
                  </Tabs>
                </TabPane>
              </Tabs> : null
          }

          <Row>
          </Row>
        
        </Card>
      </StyledContent>
    )
  }
}

const mapStateToProps = (state: Object) => ({
  permissions: state.user.permissions
})

export default connect(mapStateToProps, null)(Settings)

// export default Settings;




// WEBPACK FOOTER //
// ./src/components/setup-and-settings/index.js